import React from "react";
import {getSyncEngineVersion} from "../../../../common/helpers/syncEngine";
import PayoutV1 from "../../LogV1/payout";
import PayoutV2 from "../../LogV2/payout";

const Payout: React.FC = () => {
    return getSyncEngineVersion() === 'v2' ? <PayoutV2 /> : <PayoutV1 />;
};

export default Payout;
